import React, { useEffect } from  'react';
import './LoginPage.scss';
import LoginForm from '../LoginForm/LoginForm';
import Contact from '../Home/Contact/Contact';
import { NavLink } from 'react-router-dom';
import signImage from '../../img/sign.svg';
import { Button } from '@mui/material';


export default function LoginPage() { 
    useEffect(()=> {
        window.scrollTo({ top: 0 });
    }, []);

    return(
        <section className='loginPage'>
            <div className='loginPage_wrapper'>
                <div className='loginPage_imgWrapper'>
                    <img src={signImage} alt="sign-img" className='signImg'/>
                </div>
                <div className='loginPage_form'>
                    <LoginForm />
                    <div className='askRegister'>
                        <p>Chcesz utworzyć konto?</p>
                        <Button
                            component={NavLink}
                            to="/register"
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: '1rem',
                                borderRadius: 2,
                                px: 3,
                                py: 1,
                                backgroundColor: '#5189B0',
                                boxShadow: '0 10px 30px rgba(81, 137, 176, 0.25)',
                                '&:hover': {
                                    backgroundColor: '#63b3be',
                                    boxShadow: '0 12px 30px rgba(99, 179, 190, 0.35)',
                                },
                            }}
                        >
                            Zarejestruj sie
                        </Button>
                    </div>
                </div>
            </div>
            <Contact />
        </section>
    )
   
}